import { HeightAndWidth } from "@hooks/useRefHeightAndWidth";

const usePhonePreviewScaleFactor = (
  parentDimensions?: HeightAndWidth,
  parentVerticalPadding = 0,
  parentMinHeightBeforeScaling = 700,
  parentMinWidthBeforeScaling = 375,
): number => {
  let xScaleFactor = 1;
  let yScaleFactor = 1;
  if (!parentDimensions) return 1;
  if (
    parentDimensions.height &&
    parentDimensions.height - parentVerticalPadding <
      parentMinHeightBeforeScaling
  ) {
    yScaleFactor =
      (parentDimensions.height - parentVerticalPadding) /
      parentMinHeightBeforeScaling;
  }
  if (
    parentDimensions.width &&
    parentDimensions.width < parentMinWidthBeforeScaling
  ) {
    xScaleFactor = parentDimensions.width / parentMinWidthBeforeScaling;
  }
  return Math.min(xScaleFactor, yScaleFactor);
};

export default usePhonePreviewScaleFactor;
